<template>
  <div>
    <card class="stacked-form">
      <div class="form-group has-label">
        <div class="d-flex justify-content-between">
          <label>Info zu Stoffen, Highlights</label>
          <button class="btn btn-primary btn-sm" @click="openAddCommentDialog">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <card class="box-card" v-for="comment in comments" :key="comment.id">
        <div slot="header" class="d-flex justify-content-between">
          <span>{{ comment.user.short_name }}</span>
          <div class="d-flex" style="gap: 6px;">
            <span>{{ comment.created_at | datetime }}</span>
            <div>
              <button class="btn btn-xs btn-danger mb-0"
                @click="$emit('deleteComment', comment)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-text="comment.comment" style="white-space: pre-wrap;"></div>
      </card>
    </card>
    <comment-dialog
      :show="showCommentDialog"
      @close="showCommentDialog = false"
      @addComment="$emit('addComment', $event)"
      title="Info zu Stoffen, Highlights hinzufügen"
    />
  </div>
</template>

<script>
import CommentDialog from 'src/components/comment-dialog'

export default {
  props: ['comments'],
  components: { CommentDialog },
  data () {
    return {
      showCommentDialog: false
    }
  },
  methods: {
    openAddCommentDialog () {
      this.showCommentDialog = true
    }
  }
}
</script>

<style>
</style>
